import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import moment from "moment";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    maxWidth: "95vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
    p: { xs: 2, sm: 4 },
};

export default function ReferenceExampleModal({
    setOpenReferenceLetter,
    site,
    siteAddress,
}) {
    return (
        <Box sx={style}>
            <Paper
                variant="outlined"
                sx={{
                    position: "relative",
                    p: 2,
                    mb: 2,
                    maxHeight: "75vh",
                    overflowY: "auto",
                }}
            >
                <Typography
                    sx={{
                        position: "absolute",
                        top: 4,
                        right: 8,
                        fontSize: "0.8rem",
                        fontWeight: 700,
                    }}
                >
                    Private &amp; Confidential
                </Typography>
                <Typography variant="h5" align="center" sx={{ mt: 2 }}>
                    {site}
                </Typography>
                <Typography align="center" sx={{ mb: 2 }}>
                    {siteAddress}
                </Typography>
                <Typography sx={{ mb: 2 }}>
                    {moment().format("DD-MM-YYYY")}
                </Typography>
                <Typography sx={{ fontWeight: 700, mb: 1 }}>
                    Please read the information on this form carefully and
                    completely.
                </Typography>
                <Typography sx={{ lineHeight: 1.6, mb: 2 }}>
                    I have applied for employment with {site} and have provided
                    information about my previous employment. I authorise {site}{" "}
                    to conduct a reference check with my present and/or previous
                    employer(s). I understand that reference information may
                    include, but not limited to, verbal and written inquiries or
                    information about my employment performance, professional
                    demeanour, rehire potential, dates of employment, salary and
                    employment history.{" "}
                </Typography>
                <Typography sx={{ lineHeight: 1.6, mb: 2 }}>
                    My signature below authorises my former or current employers
                    and references to release information regarding my
                    employment record with their organisation and to provide any
                    additional information that may be necessary for my
                    application for employment with {site}, whether this
                    information is positive or negative.
                </Typography>
                <Typography sx={{ lineHeight: 1.6, mb: 2 }}>
                    This form may be photocopied and these copies will be as
                    effective as the original form which I have signed.
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6} sx={{ minHeight: 100 }}>
                        <Typography sx={{ fontWeight: 700 }}>Name:</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ minHeight: 100 }}>
                        <Typography sx={{ fontWeight: 700 }}>Signature:</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ minHeight: 100 }}>
                        <Typography sx={{ fontWeight: 700 }}>Date:</Typography>
                        <Typography>{moment().format("DD-MM-YYYY")}</Typography>
                    </Grid>
                </Grid>
            </Paper>
            <Button
                variant="contained"
                color="error"
                fullWidth
                onClick={() => setOpenReferenceLetter(false)}
            >
                Close
            </Button>
        </Box>
    );
}
